import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { CartCouponComponent } from '@spartacus/cart/base/components';
import { ActiveCartFacade, Cart, CartVoucherFacade } from '@spartacus/cart/base/root';
import { CustomerCouponService, GlobalMessageService, Translatable } from '@spartacus/core';
import { Observable } from 'rxjs';
import { GenCartCouponService } from 'src/app/generac/services/cart-coupon.service';

@Component({
    selector: 'gen-cart-coupon',
    templateUrl: './cart-coupon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenCartCouponComponent extends CartCouponComponent {
  error$: Observable<string | Translatable>;
  override cart$: Observable<Cart>;

  constructor(
    protected override cartVoucherService: CartVoucherFacade,
    protected override formBuilder: UntypedFormBuilder,
    protected override customerCouponService: CustomerCouponService,
    protected override activeCartService: ActiveCartFacade,
    public globalMessageService: GlobalMessageService,
    public cartCouponService: GenCartCouponService,
    protected el: ElementRef,
  ) {
    super(cartVoucherService, formBuilder, customerCouponService, activeCartService);
    this.error$ = this.cartCouponService.getError();
  }

  clearError(): void {
    this.cartCouponService.removeError();
  }

}
